
export default {
  data() {
    return {
      title: "Advocacy | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "advocacy",
          name: "advocacy",
          content:
            "We are proud to support the following non-profit cycling organizations and their efforts to grow opportunities and make the sport safer for cyclists of all ages and types. We believe we can make a difference in making cycling better for all of us.",
        },
      ],
    };
  },
};
